export const APPLICATION_INITIALIZED = 'APPLICATION_INITIALIZED';




// WEBPACK FOOTER //
// ./src/store/modules/application/actions.ts